import React from 'react';

import { useStoreListingWizard } from '../hooks';
import { CreateModeChooseProduct } from './CreateModeChooseProduct';
import { EditModeProductInformation } from './EditModeProductInformation';

export function ChooseProductStep() {
  const { contextData } = useStoreListingWizard();

  const isEdit = contextData.storeListing !== undefined;

  if (isEdit) {
    return <EditModeProductInformation />;
  }

  return <CreateModeChooseProduct />;
}
